module.exports = __webpack_public_path__ + "static/media/close.78343b0f.svg";